export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/warning-93e228eda09c5f164f6851f8e31e5e8f.svg";